import type { ZodiacSign } from "./database.types";

export interface SignInfo {
  slug: ZodiacSign;
  name: string;
  symbol: string;
  element: "Fuego" | "Tierra" | "Aire" | "Agua";
  rulingPlanet: string;
  dateRange: string;
  color: string;
  description: string;
}

export const SIGNS: SignInfo[] = [
  {
    slug: "aries",
    name: "Aries",
    symbol: "♈",
    element: "Fuego",
    rulingPlanet: "Marte",
    dateRange: "21 mar — 19 abr",
    color: "from-red-500 to-orange-500",
    description: "Pioneros, valientes y apasionados.",
  },
  {
    slug: "tauro",
    name: "Tauro",
    symbol: "♉",
    element: "Tierra",
    rulingPlanet: "Venus",
    dateRange: "20 abr — 20 may",
    color: "from-emerald-500 to-green-600",
    description: "Estables, sensuales y determinados.",
  },
  {
    slug: "geminis",
    name: "Géminis",
    symbol: "♊",
    element: "Aire",
    rulingPlanet: "Mercurio",
    dateRange: "21 may — 20 jun",
    color: "from-yellow-400 to-amber-500",
    description: "Curiosos, ingeniosos y comunicadores.",
  },
  {
    slug: "cancer",
    name: "Cáncer",
    symbol: "♋",
    element: "Agua",
    rulingPlanet: "Luna",
    dateRange: "21 jun — 22 jul",
    color: "from-slate-300 to-blue-300",
    description: "Emocionales, protectores e intuitivos.",
  },
  {
    slug: "leo",
    name: "Leo",
    symbol: "♌",
    element: "Fuego",
    rulingPlanet: "Sol",
    dateRange: "23 jul — 22 ago",
    color: "from-amber-500 to-yellow-600",
    description: "Líderes, creativos y magnánimos.",
  },
  {
    slug: "virgo",
    name: "Virgo",
    symbol: "♍",
    element: "Tierra",
    rulingPlanet: "Mercurio",
    dateRange: "23 ago — 22 sep",
    color: "from-emerald-600 to-teal-600",
    description: "Analíticos, perfeccionistas y serviciales.",
  },
  {
    slug: "libra",
    name: "Libra",
    symbol: "♎",
    element: "Aire",
    rulingPlanet: "Venus",
    dateRange: "23 sep — 22 oct",
    color: "from-pink-400 to-rose-500",
    description: "Diplomáticos, elegantes y amantes del equilibrio.",
  },
  {
    slug: "escorpio",
    name: "Escorpio",
    symbol: "♏",
    element: "Agua",
    rulingPlanet: "Plutón",
    dateRange: "23 oct — 21 nov",
    color: "from-red-700 to-purple-900",
    description: "Intensos, magnéticos y transformadores.",
  },
  {
    slug: "sagitario",
    name: "Sagitario",
    symbol: "♐",
    element: "Fuego",
    rulingPlanet: "Júpiter",
    dateRange: "22 nov — 21 dic",
    color: "from-purple-500 to-indigo-600",
    description: "Aventureros, filósofos y optimistas.",
  },
  {
    slug: "capricornio",
    name: "Capricornio",
    symbol: "♑",
    element: "Tierra",
    rulingPlanet: "Saturno",
    dateRange: "22 dic — 19 ene",
    color: "from-stone-600 to-slate-800",
    description: "Ambiciosos, disciplinados y responsables.",
  },
  {
    slug: "acuario",
    name: "Acuario",
    symbol: "♒",
    element: "Aire",
    rulingPlanet: "Urano",
    dateRange: "20 ene — 18 feb",
    color: "from-cyan-400 to-sky-600",
    description: "Originales, humanistas y visionarios.",
  },
  {
    slug: "piscis",
    name: "Piscis",
    symbol: "♓",
    element: "Agua",
    rulingPlanet: "Neptuno",
    dateRange: "19 feb — 20 mar",
    color: "from-indigo-400 to-violet-500",
    description: "Empáticos, soñadores y espirituales.",
  },
];

export const getSignBySlug = (slug: string): SignInfo | undefined =>
  SIGNS.find((s) => s.slug === slug);
